import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { StepIndicator } from '@uhg-abyss/web/ui/StepIndicator';
import { Text } from '@uhg-abyss/web/ui/Text';

const Container = styled('div', {
  paddingBottom: '32px',
  paddingTop: '32px',
  background: 'rgb(255, 255, 255)',
  borderBottomLeftRadius: 4,
  borderBottomRightRadius: 4,
});

const TrackerHeader = styled('div', {
  textAlign: 'center',
  paddingTop: '1%',
  paddingBottom: '2%',
});

export const OrganizationTracker = ({ currentStep }) => {
  return (
    <Container>
      <TrackerHeader>
        <Text id="tracker-label" size="lg">
          API Subscription Request Status
        </Text>
      </TrackerHeader>
      <StepIndicator currentStep={currentStep}>
        <StepIndicator.Step
          id="step-request-submitted"
          label="Request Submitted"
        />
        <StepIndicator.Step id="step-review" label="Reviewing Request" />
        <StepIndicator.Step id="step-approved" label="API Request Approved" />
      </StepIndicator>
    </Container>
  );
};

OrganizationTracker.propTypes = {
  currentStep: PropTypes.number.isRequired,
};
